module.exports = __webpack_public_path__ + "img/9.ce2b7dd9.png";